export default __webpack_public_path__ + "static/giacosa-5f28557deeebad12a2601b5de6c715f6.jpg";